import Footer from "components/reuseable/Footer";
import Navbar from "components/reuseable/Navbar";
import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { performSessionCheck } from "utils/redux/session/sessionActions";

const Layout = () => {
  let navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [sessionLoading, setSessionLoading] = useState(true);
  
  // Session state dari Redux
  const { isValid, isLoading, isChecking, hasChecked } = useSelector((state) => state.session || {});

  useEffect(() => {
    setSessionLoading(true);
    dispatch(performSessionCheck(5000))
      .then(() => {
        setSessionLoading(false);
      })
      .catch(() => {
        setSessionLoading(false);
      });
  }, [pathname, dispatch]);

  // Redirect ke app index jika sudah login (production flow)
  useEffect(() => {
    if (isValid) {
      const base = (process.env.REACT_APP_API_ORI || '').replace(/\/$/, '');
      window.location.replace(`${base}/app/index`);
    }
  }, [isValid]);

  useEffect(() => {
    if (pathname === "/") {
      navigate("/home");
    }
  }, [pathname, navigate]);

  const isLoginPage = pathname.startsWith("/login");
  const isResetPasswordPage = pathname === "/reset-password";

  // Tampilkan loading screen jika session sedang dicek
  if (sessionLoading && !isLoginPage && !isResetPasswordPage) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto mb-4"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-col">
        {/* <Navbar /> */}
        {!isLoginPage && !isResetPasswordPage && <Navbar />}

        <div className="body-section min-h-screen">
          <Outlet />
        </div>
        {!isLoginPage && !isResetPasswordPage && <Footer />}
      </div>
    </>
  );
};

export default Layout;
